/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  JobSpecTemplateListItemDto,
  OfficeListItemDto,
  ScheduleTemplateListItemDto,
  SendToOfficeItemDto,
} from '@gh/builder-shared-data';

export type SendToOfficeItem = SendToOfficeItemDto;
export type OfficeListItem = OfficeListItemDto;
export type JobSpecTemplateListItem = JobSpecTemplateListItemDto;
export type ScheduleTemplateListItem = ScheduleTemplateListItemDto;

export enum SourceType {
  HousePlans = 'HousePlans',
  JobSpecTemplates = 'JobSpecTemplates',
  CSMaster = 'CSMaster',
  ScheduleTemplates = 'ScheduleTemplates',
}
